export const BUCKET_MODEL_NUMBER = 'bucketModelNumber';
export const SPECIALS_FACETS = 'SPECIALS_FACET';
export const LONG_TEXT_LANGUAGES = {
  ru: 'ru_RU'
};
